const sdkConfig = {
    AUTHTOKEN_KEY: 'edf31',
    iv: '0000000000000000'
}

export default sdkConfig;